import { styled } from '../jss-style';
import tagStyle from './tag';

const useTagStyle = styled(tagStyle, 'tag');

export { tagStyle, useTagStyle };
export default useTagStyle;
